export enum AuthenticationType {
  LOGIN,
  REGISTER,
}
